export interface MangaCategory {
  slug: string;
  name: string;
  description: string;
}

export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Manga {
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updatedAt: string;
  chapters: MangaChapter[];
  tags: string[];
}

export const categories: MangaCategory[] = [
  { slug: 'shaonian-rexue', name: '少年热血', description: '热血沸腾的少年冒险故事，勇气与友情的赞歌' },
  { slug: 'lianai-qinggan', name: '恋爱情感', description: '甜蜜温馨的恋爱故事，触动心弦的情感之旅' },
  { slug: 'xuanhuan-mofa', name: '玄幻魔法', description: '奇幻世界的魔法冒险，超乎想象的精彩旅程' },
  { slug: 'gaoxiao-rihe', name: '搞笑日和', description: '轻松幽默的日常喜剧，让你开怀大笑' },
  { slug: 'xuanyi-kehuan', name: '悬疑科幻', description: '扣人心弦的悬疑故事，未来科技的无限想象' },
  { slug: 'wuxia-xiuzhen', name: '武侠修真', description: '江湖侠客的传奇人生，修真世界的无限可能' },
  { slug: 'kongbu-lingyi', name: '恐怖灵异', description: '惊险刺激的灵异故事，挑战你的胆量极限' },
  { slug: 'richang-qingchun', name: '日常青春', description: '青春校园的温暖日常，成长路上的点滴回忆' },
];

export const mangas: Manga[] = [
  {
    slug: 'mi-tao-shao-nian',
    title: '蜜桃少年',
    author: '桃花先生',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20boy%20with%20peach%20blossom%20pink%20hair%20soft%20warm%20lighting%20school%20uniform%20romantic%20atmosphere%20cherry%20blossom%20petals%20falling%20gentle%20smile%20shojo%20manga%20cover%20art%20style%20clean%20composition%20with%20soft%20gradient%20background%20pastel%20peach%20tones&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '在樱花飞舞的校园里，少年林桃遇见了改变他命运的少女。一段关于青春、成长与初恋的甜蜜故事就此展开。蜜桃般的少年，带着青涩的甜蜜，走进了每个人的心里。这是一个关于勇气与成长的故事，也是一个关于梦想与爱的诗篇。',
    categories: ['shaonian-rexue', 'lianai-qinggan', 'richang-qingchun'],
    status: '连载中',
    rating: 9.5,
    views: 1286000,
    updatedAt: '2026-08-03',
    tags: ['校园', '青春', '初恋', '成长', '甜蜜'],
    chapters: [
      { id: 'ch-1', title: '第1话 樱花树下的邂逅', number: 1, updatedAt: '2026-07-01' },
      { id: 'ch-2', title: '第2话 转校生的秘密', number: 2, updatedAt: '2026-07-05' },
      { id: 'ch-3', title: '第3话 图书馆的午后', number: 3, updatedAt: '2026-07-09' },
      { id: 'ch-4', title: '第4话 夏日祭的约定', number: 4, updatedAt: '2026-07-13' },
      { id: 'ch-5', title: '第5话 突如其来的告白', number: 5, updatedAt: '2026-07-17' },
      { id: 'ch-6', title: '第6话 心跳加速的距离', number: 6, updatedAt: '2026-07-21' },
      { id: 'ch-7', title: '第7话 雨中的拥抱', number: 7, updatedAt: '2026-07-25' },
      { id: 'ch-8', title: '第8话 彼此的真心', number: 8, updatedAt: '2026-07-29' },
      { id: 'ch-9', title: '第9话 新学期开始', number: 9, updatedAt: '2026-08-02' },
      { id: 'ch-10', title: '第10话 文化祭的准备', number: 10, updatedAt: '2026-08-03' },
    ],
  },
  {
    slug: 'yan-zhi-zhan-shen',
    title: '炎之战神',
    author: '烈火居士',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20warrior%20with%20flaming%20red%20hair%20holding%20sword%20epic%20battle%20scene%20dramatic%20lighting%20fire%20elements%20surrounding%20action%20pose%20shonen%20manga%20cover%20art%20intense%20expression%20dark%20background%20with%20flame%20effects%20heroic%20stance&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '在远古的炎之大陆上，少年炎烈继承了战神的血脉，肩负着守护大陆和平的使命。面对黑暗势力的侵袭，他必须不断突破自我，觉醒体内沉睡的力量。热血沸腾的战斗场面，感人至深的友情羁绊，一部不容错过的史诗级少年漫画。',
    categories: ['shaonian-rexue', 'xuanhuan-mofa'],
    status: '连载中',
    rating: 9.3,
    views: 965000,
    updatedAt: '2026-08-02',
    tags: ['战斗', '热血', '冒险', '奇幻', '成长'],
    chapters: [
      { id: 'ch-1', title: '第1话 战神的觉醒', number: 1, updatedAt: '2026-06-15' },
      { id: 'ch-2', title: '第2话 烈焰之剑', number: 2, updatedAt: '2026-06-20' },
      { id: 'ch-3', title: '第3话 黑暗降临', number: 3, updatedAt: '2026-06-25' },
      { id: 'ch-4', title: '第4话 伙伴集结', number: 4, updatedAt: '2026-06-30' },
      { id: 'ch-5', title: '第5话 龙之试炼', number: 5, updatedAt: '2026-07-05' },
      { id: 'ch-6', title: '第6话 绝境逢生', number: 6, updatedAt: '2026-07-10' },
      { id: 'ch-7', title: '第7话 最终决战', number: 7, updatedAt: '2026-07-18' },
      { id: 'ch-8', title: '第8话 新的征程', number: 8, updatedAt: '2026-08-02' },
    ],
  },
  {
    slug: 'xing-kong-xia-de-yue-ding',
    title: '星空下的约定',
    author: '月下独酌',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20couple%20under%20starry%20night%20sky%20romantic%20scene%20boy%20and%20girl%20holding%20hands%20beautiful%20starlight%20background%20shojo%20manga%20cover%20art%20soft%20blue%20and%20purple%20tones%20dreamy%20atmosphere%20gentle%20expressions%20twinkling%20stars&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '天文社的少女夏星在一次观星活动中，遇见了同样热爱星空的少年陈宇。两人约定在每个晴朗的夜晚一起观测星空，记录下最美的星辰。然而命运却给这对少年少女出了一道难题。一段关于星空、梦想与纯爱的青春物语。',
    categories: ['lianai-qinggan', 'richang-qingchun'],
    status: '已完结',
    rating: 9.6,
    views: 1532000,
    updatedAt: '2026-06-30',
    tags: ['恋爱', '校园', '星空', '青春', '纯爱'],
    chapters: [
      { id: 'ch-1', title: '第1话 天台上的星空', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-2', title: '第2话 天文社的新成员', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch-3', title: '第3话 流星雨的夜晚', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch-4', title: '第4话 夏日的星座', number: 4, updatedAt: '2026-05-22' },
      { id: 'ch-5', title: '第5话 远方的来信', number: 5, updatedAt: '2026-05-29' },
      { id: 'ch-6', title: '第6话 两年后的重逢', number: 6, updatedAt: '2026-06-05' },
      { id: 'ch-7', title: '第7话 永恒的约定', number: 7, updatedAt: '2026-06-12' },
      { id: 'ch-8', title: '第8话 星空下的誓言（完）', number: 8, updatedAt: '2026-06-30' },
    ],
  },
  {
    slug: 'mo-fa-xue-yuan-lu',
    title: '魔法学院录',
    author: '魔法学徒',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20magic%20academy%20students%20in%20robes%20holding%20magic%20wands%20mystical%20school%20background%20floating%20spell%20books%20magical%20energy%20effects%20fantasy%20manga%20cover%20art%20warm%20golden%20lighting%20enchanting%20atmosphere&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '平凡少年白羽意外收到了圣罗兰魔法学院的录取通知书。在这个充满魔法与奇迹的世界里，他将结识来自不同种族的伙伴，学习各种神奇的魔法，揭开学院隐藏千年的秘密。一场充满欢笑与泪水的魔法冒险即将开始。',
    categories: ['xuanhuan-mofa', 'gaoxiao-rihe'],
    status: '连载中',
    rating: 9.2,
    views: 876000,
    updatedAt: '2026-08-01',
    tags: ['魔法', '学院', '奇幻', '冒险', '搞笑'],
    chapters: [
      { id: 'ch-1', title: '第1话 录取通知书', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch-2', title: '第2话 入学测试', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch-3', title: '第3话 室友是精灵族', number: 3, updatedAt: '2026-06-15' },
      { id: 'ch-4', title: '第4话 第一节魔法课', number: 4, updatedAt: '2026-06-22' },
      { id: 'ch-5', title: '第5话 禁书区的秘密', number: 5, updatedAt: '2026-06-29' },
      { id: 'ch-6', title: '第6话 魔法竞技大会', number: 6, updatedAt: '2026-07-06' },
      { id: 'ch-7', title: '第7话 暗影中的阴谋', number: 7, updatedAt: '2026-07-15' },
      { id: 'ch-8', title: '第8话 勇闯地下迷宫', number: 8, updatedAt: '2026-07-22' },
      { id: 'ch-9', title: '第9话 千年之秘', number: 9, updatedAt: '2026-08-01' },
    ],
  },
  {
    slug: 'chao-neng-te-gong-dui',
    title: '超能特工队',
    author: '暗影使者',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20agent%20team%20in%20black%20tactical%20suits%20futuristic%20city%20background%20action%20pose%20sci-fi%20elements%20neon%20lights%20superpower%20effects%20thriller%20manga%20cover%20art%20dynamic%20composition%20dramatic%20shadows&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '在不远的未来，超能力者成为各国秘密培养的特工。少年陆风因一次意外觉醒了自己的超能力——时间暂停，随后被神秘组织招募。面对各种危险的任务和隐藏在暗处的敌人，他和队友们将如何守护世界的和平？',
    categories: ['xuanyi-kehuan', 'shaonian-rexue'],
    status: '连载中',
    rating: 9.4,
    views: 1120000,
    updatedAt: '2026-08-03',
    tags: ['超能力', '特工', '科幻', '悬疑', '战斗'],
    chapters: [
      { id: 'ch-1', title: '第1话 觉醒之日', number: 1, updatedAt: '2026-06-10' },
      { id: 'ch-2', title: '第2话 神秘组织', number: 2, updatedAt: '2026-06-17' },
      { id: 'ch-3', title: '第3话 第一次任务', number: 3, updatedAt: '2026-06-24' },
      { id: 'ch-4', title: '第4话 队友的秘密', number: 4, updatedAt: '2026-07-01' },
      { id: 'ch-5', title: '第5话 叛徒现身', number: 5, updatedAt: '2026-07-08' },
      { id: 'ch-6', title: '第6话 生死时速', number: 6, updatedAt: '2026-07-16' },
      { id: 'ch-7', title: '第7话 真相大白', number: 7, updatedAt: '2026-07-24' },
      { id: 'ch-8', title: '第8话 最终兵器', number: 8, updatedAt: '2026-08-03' },
    ],
  },
  {
    slug: 'jian-qi-jiu-xiao',
    title: '剑气九霄',
    author: '剑道无极',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20swordsman%20in%20traditional%20hanfu%20robes%20flying%20on%20sword%20ancient%20Chinese%20landscape%20mountains%20and%20clouds%20martial%20arts%20wuxia%20manga%20cover%20art%20elegant%20pose%20ink%20wash%20painting%20style%20misty%20atmosphere&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '在修真界最底层的小门派中，少年剑尘凭借一把残缺的古剑，一步步踏上剑道巅峰。从被人瞧不起的废物到令天下敬畏的剑尊，他用手中之剑劈开了一条逆天之路。传统武侠与现代审美的完美结合，演绎一段荡气回肠的修真传奇。',
    categories: ['wuxia-xiuzhen', 'xuanhuan-mofa'],
    status: '连载中',
    rating: 9.1,
    views: 789000,
    updatedAt: '2026-08-01',
    tags: ['武侠', '修真', '剑道', '逆袭', '古风'],
    chapters: [
      { id: 'ch-1', title: '第1话 废物弟子', number: 1, updatedAt: '2026-05-20' },
      { id: 'ch-2', title: '第2话 残缺古剑', number: 2, updatedAt: '2026-05-28' },
      { id: 'ch-3', title: '第3话 剑意初成', number: 3, updatedAt: '2026-06-05' },
      { id: 'ch-4', title: '第4话 宗门大比', number: 4, updatedAt: '2026-06-12' },
      { id: 'ch-5', title: '第5话 一战成名', number: 5, updatedAt: '2026-06-20' },
      { id: 'ch-6', title: '第6话 秘境探险', number: 6, updatedAt: '2026-07-01' },
      { id: 'ch-7', title: '第7话 剑道真谛', number: 7, updatedAt: '2026-07-12' },
      { id: 'ch-8', title: '第8话 九霄之上', number: 8, updatedAt: '2026-07-25' },
      { id: 'ch-9', title: '第9话 天劫降临', number: 9, updatedAt: '2026-08-01' },
    ],
  },
  {
    slug: 'ling-yi-shi-wu-suo',
    title: '灵异事务所',
    author: '夜半惊魂',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20supernatural%20investigators%20in%20dark%20alley%20ghostly%20figures%20mysterious%20atmosphere%20horror%20manga%20cover%20art%20cold%20blue%20tones%20eerie%20lighting%20shadowy%20corners%20suspenseful%20composition%20urban%20legend%20theme&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '都市传说中，有一家只在午夜开门的事务所，专门处理各种超自然事件。大学生沈默偶然闯入这家事务所，从此开启了一段段惊心动魄的灵异冒险。每一个故事都引人入胜，每一个谜团都让人欲罢不能。准备好了吗？进入这个充满未知的世界。',
    categories: ['kongbu-lingyi', 'xuanyi-kehuan'],
    status: '连载中',
    rating: 8.9,
    views: 654000,
    updatedAt: '2026-07-30',
    tags: ['灵异', '恐怖', '悬疑', '都市传说', '超自然'],
    chapters: [
      { id: 'ch-1', title: '第1话 午夜的访客', number: 1, updatedAt: '2026-05-15' },
      { id: 'ch-2', title: '第2话 哭泣的玩偶', number: 2, updatedAt: '2026-05-22' },
      { id: 'ch-3', title: '第3话 镜中的倒影', number: 3, updatedAt: '2026-05-30' },
      { id: 'ch-4', title: '第4话 废弃医院', number: 4, updatedAt: '2026-06-08' },
      { id: 'ch-5', title: '第5话 红衣小女孩', number: 5, updatedAt: '2026-06-18' },
      { id: 'ch-6', title: '第6话 消失的404房间', number: 6, updatedAt: '2026-07-01' },
      { id: 'ch-7', title: '第7话 亡者的低语', number: 7, updatedAt: '2026-07-20' },
      { id: 'ch-8', title: '第8话 事务所的秘密', number: 8, updatedAt: '2026-07-30' },
    ],
  },
  {
    slug: 'gao-xiao-ri-chang-bu',
    title: '搞笑日常部',
    author: '快乐小丑',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20comedy%20school%20club%20members%20making%20funny%20faces%20bright%20colorful%20background%20exaggerated%20expressions%20comedy%20manga%20cover%20art%20lively%20atmosphere%20chibi%20style%20characters%20humorous%20scene%20warm%20yellow%20tones&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '高中一年级的搞笑日常社团，聚集了一群性格迥异的怪人。有天然呆的社长、中二病的副社长、还有永远在状况外的社员们。每一页都充满笑料，每一格都让人捧腹大笑。生活已经够累了，不如来笑一笑吧！',
    categories: ['gaoxiao-rihe', 'richang-qingchun'],
    status: '连载中',
    rating: 9.0,
    views: 523000,
    updatedAt: '2026-08-02',
    tags: ['搞笑', '校园', '日常', '喜剧', '轻松'],
    chapters: [
      { id: 'ch-1', title: '第1话 社团招新大作战', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch-2', title: '第2话 社长的秘密', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch-3', title: '第3话 学园祭的灾难', number: 3, updatedAt: '2026-06-15' },
      { id: 'ch-4', title: '第4话 合宿大暴走', number: 4, updatedAt: '2026-06-22' },
      { id: 'ch-5', title: '第5话 期末考试危机', number: 5, updatedAt: '2026-07-01' },
      { id: 'ch-6', title: '第6话 暑假的奇遇', number: 6, updatedAt: '2026-07-10' },
      { id: 'ch-7', title: '第7话 新学期的混乱', number: 7, updatedAt: '2026-07-20' },
      { id: 'ch-8', title: '第8话 文化祭的前夜', number: 8, updatedAt: '2026-08-02' },
    ],
  },
  {
    slug: 'qing-chun-wu-xian-hao',
    title: '青春无限好',
    author: '时光旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20high%20school%20students%20walking%20under%20cherry%20blossom%20trees%20spring%20sunlight%20youthful%20slice%20of%20life%20manga%20cover%20art%20warm%20nostalgic%20atmosphere%20group%20of%20friends%20smiling%20soft%20pastel%20colors%20peaceful%20school%20courtyard&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '四个性格各异的高中生，在最好的年华里相遇。有欢笑、有泪水、有争吵、也有和解。他们一起度过了最难忘的三年高中时光。这是一个关于友情、梦想与青春的故事，献给每一个曾在校园里奔跑过的你。',
    categories: ['richang-qingchun', 'lianai-qinggan'],
    status: '已完结',
    rating: 9.7,
    views: 1890000,
    updatedAt: '2026-05-20',
    tags: ['青春', '校园', '友情', '成长', '日常'],
    chapters: [
      { id: 'ch-1', title: '第1话 开学第一天', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch-2', title: '第2话 同桌的你', number: 2, updatedAt: '2026-03-08' },
      { id: 'ch-3', title: '第3话 运动会', number: 3, updatedAt: '2026-03-15' },
      { id: 'ch-4', title: '第4话 暑假补习', number: 4, updatedAt: '2026-03-22' },
      { id: 'ch-5', title: '第5话 学园祭之星', number: 5, updatedAt: '2026-04-01' },
      { id: 'ch-6', title: '第6话 分歧与和解', number: 6, updatedAt: '2026-04-10' },
      { id: 'ch-7', title: '第7话 毕业旅行', number: 7, updatedAt: '2026-04-20' },
      { id: 'ch-8', title: '第8话 各自的未来', number: 8, updatedAt: '2026-05-01' },
      { id: 'ch-9', title: '第9话 十年后的我们（完）', number: 9, updatedAt: '2026-05-20' },
    ],
  },
  {
    slug: 'mo-jie-zhi-men',
    title: '魔界之门',
    author: '暗夜游侠',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20dark%20fantasy%20demon%20gate%20opening%20hero%20standing%20before%20it%20epic%20scale%20mystical%20energy%20swirling%20dark%20fantasy%20manga%20cover%20art%20dramatic%20contrast%20light%20and%20shadow%20gothic%20elements%20heroic%20silhouette&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '千年一遇的魔界之门即将开启，人间面临前所未有的危机。少年勇者艾伦在命运的指引下，踏上封印魔界之门的艰难征途。沿途结识的伙伴、遭遇的敌人、经历的考验，都将成为他成长路上最珍贵的财富。',
    categories: ['shaonian-rexue', 'xuanhuan-mofa'],
    status: '连载中',
    rating: 9.3,
    views: 912000,
    updatedAt: '2026-08-03',
    tags: ['冒险', '勇者', '魔幻', '战斗', '史诗'],
    chapters: [
      { id: 'ch-1', title: '第1话 预言之子', number: 1, updatedAt: '2026-06-20' },
      { id: 'ch-2', title: '第2话 启程之日', number: 2, updatedAt: '2026-06-28' },
      { id: 'ch-3', title: '第3话 精灵之森', number: 3, updatedAt: '2026-07-05' },
      { id: 'ch-4', title: '第4话 矮人铁匠', number: 4, updatedAt: '2026-07-12' },
      { id: 'ch-5', title: '第5话 龙之谷', number: 5, updatedAt: '2026-07-20' },
      { id: 'ch-6', title: '第6话 魔王城堡', number: 6, updatedAt: '2026-07-28' },
      { id: 'ch-7', title: '第7话 最终封印', number: 7, updatedAt: '2026-08-03' },
    ],
  },
  {
    slug: 'ni-xi-de-lian-ren',
    title: '逆袭的恋人',
    author: '甜蜜风暴',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20handsome%20boy%20and%20cute%20girl%20facing%20each%20other%20romantic%20sparkles%20pink%20heart%20background%20shojo%20romance%20manga%20cover%20art%20sweet%20atmosphere%20blushing%20expressions%20soft%20pastel%20colors%20dreamy%20bokeh%20effects&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '平凡女孩苏小暖暗恋校草三年，却始终不敢表白。一次意外的身份互换，让她变成了校园里最受欢迎的女生。当她以全新的身份站在他面前时，一切都变得不一样了。甜蜜又搞笑的反转恋爱喜剧，绝对让你少女心爆棚。',
    categories: ['lianai-qinggan', 'gaoxiao-rihe'],
    status: '连载中',
    rating: 9.2,
    views: 745000,
    updatedAt: '2026-08-01',
    tags: ['恋爱', '喜剧', '校园', '变身', '甜蜜'],
    chapters: [
      { id: 'ch-1', title: '第1话 暗恋日记', number: 1, updatedAt: '2026-06-05' },
      { id: 'ch-2', title: '第2话 奇妙变身', number: 2, updatedAt: '2026-06-12' },
      { id: 'ch-3', title: '第3话 初次对话', number: 3, updatedAt: '2026-06-19' },
      { id: 'ch-4', title: '第4话 他的秘密', number: 4, updatedAt: '2026-06-26' },
      { id: 'ch-5', title: '第5话 情敌出现', number: 5, updatedAt: '2026-07-05' },
      { id: 'ch-6', title: '第6话 告白大作战', number: 6, updatedAt: '2026-07-15' },
      { id: 'ch-7', title: '第7话 真心话大冒险', number: 7, updatedAt: '2026-07-25' },
      { id: 'ch-8', title: '第8话 逆袭的结局', number: 8, updatedAt: '2026-08-01' },
    ],
  },
  {
    slug: 'ji-yuan-zhi-cheng',
    title: '纪元之城',
    author: '未来建筑师',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhwa%20style%20anime%20futuristic%20cyberpunk%20city%20neon%20lights%20hovering%20vehicles%20sci-fi%20manga%20cover%20art%20dystopian%20atmosphere%20high%20tech%20buildings%20hologram%20screens%20rainy%20night%20scene%20mysterious%20protagonist%20in%20hoodie&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '2146年，人类建立了完全由人工智能管理的纪元之城。表面上完美的城市背后，却隐藏着不为人知的黑暗秘密。黑客少年零号在破解城市系统时，意外发现了足以颠覆整个世界的真相。一部硬核科幻悬疑大作。',
    categories: ['xuanyi-kehuan', 'shaonian-rexue'],
    status: '连载中',
    rating: 9.4,
    views: 832000,
    updatedAt: '2026-07-29',
    tags: ['科幻', '未来', 'AI', '悬疑', '黑客'],
    chapters: [
      { id: 'ch-1', title: '第1话 完美之城', number: 1, updatedAt: '2026-05-10' },
      { id: 'ch-2', title: '第2话 地下黑客', number: 2, updatedAt: '2026-05-18' },
      { id: 'ch-3', title: '第3话 系统漏洞', number: 3, updatedAt: '2026-05-26' },
      { id: 'ch-4', title: '第4话 追杀令', number: 4, updatedAt: '2026-06-03' },
      { id: 'ch-5', title: '第5话 反抗组织', number: 5, updatedAt: '2026-06-15' },
      { id: 'ch-6', title: '第6话 真相浮现', number: 6, updatedAt: '2026-06-28' },
      { id: 'ch-7', title: '第7话 终极抉择', number: 7, updatedAt: '2026-07-15' },
      { id: 'ch-8', title: '第8话 自由之日', number: 8, updatedAt: '2026-07-29' },
    ],
  },
];

export const featuredMangaSlugs = ['mi-tao-shao-nian', 'yan-zhi-zhan-shen', 'xing-kong-xia-de-yue-ding', 'chao-neng-te-gong-dui', 'mo-fa-xue-yuan-lu'];

export const latestUpdatedSlugs = ['mi-tao-shao-nian', 'chao-neng-te-gong-dui', 'mo-jie-zhi-men', 'gao-xiao-ri-chang-bu', 'ni-xi-de-lian-ren', 'jian-qi-jiu-xiao', 'yan-zhi-zhan-shen', 'ling-yi-shi-wu-suo'];

export const popularSlugs = ['xing-kong-xia-de-yue-ding', 'qing-chun-wu-xian-hao', 'mi-tao-shao-nian', 'ji-yuan-zhi-cheng', 'chao-neng-te-gong-dui', 'yan-zhi-zhan-shen'];